import { render, staticRenderFns } from "./OrderDialogItem.vue?vue&type=template&id=6d1be9d6&scoped=true&"
import script from "./OrderDialogItem.vue?vue&type=script&lang=js&"
export * from "./OrderDialogItem.vue?vue&type=script&lang=js&"
import style0 from "./OrderDialogItem.vue?vue&type=style&index=0&id=6d1be9d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d1be9d6",
  null
  
)

export default component.exports